<template>
  <CChartLine
    :datasets="computedDatasets"
    :options="computedOptions"
    :labels="timeData?timeData:chartLabels"
  />
  <!-- :options="computedOptions" -->
</template>

<script>
import { CChartLine } from 'vue-chartjs-new' 
import { getColor, deepObjectsMerge } from '@coreui/utils/src'

export default {
  name: 'CChartLineSimple',
  components: { CChartLine },
  props: {
    ...CChartLine.props,
    borderColor: {
      type: String,
      default: 'rgba(255,255,255,.55)'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    timeData:{
      type: Array,
      default:null
      
    },
    chartLabels: {
      type: Array|String,
      
    },
    dataPoints: {
      type: Array,
      //default: () => [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12] //dummy values
    },
    label: {
      type: String,
      default: function () {
    return this.$t('dashBoard.cChartLineSimple.sales')
      }
    },
    pointed: Boolean,
    pointHoverBackgroundColor: String
  },
  data(){
    return{
      searchLabel:null
    }
  },
  methods:{ 
    
  },

  computed: {
    pointHoverColor () {
      if (this.pointHoverBackgroundColor) {
        return this.pointHoverBackgroundColor
      } else if (this.backgroundColor !== 'transparent') {
        return this.backgroundColor
      }
      return this.borderColor
    },
    defaultDatasets () {
      return [
        {
          data: this.dataPoints,
          borderColor: "#89d27a",//getColor(this.borderColor),
          backgroundColor: "#def3da",//getColor(this.backgroundColor),
          pointBackgroundColor: "#89d27a",//getColor(this.pointHoverColor),
          pointHoverBackgroundColor: "#89d27a",//getColor(this.pointHoverColor),
          label: this.$t('dashBoard.cChartLineSimple.searchCount')
        }
      ]
    },
    pointedOptions () {
      return {
        scales: {
          xAxes: [
            {
              offset: true,
              gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
              },
              ticks: {
                fontSize: 2,
                fontColor: 'transparent'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: false,
                min: Math.min.apply(Math, this.dataPoints) - 5,
                max: Math.max.apply(Math, this.dataPoints) + 5
              }
            }
          ]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 2,
            hitRadius: 10,
            hoverRadius: 4
          }
        },
        tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                    label: function(tooltipItems, data) { 
                  
                      // return 'Search Count '+tooltipItems.yLabel+' - '+data.labels[tooltipItems.index];
                      // return 'Search Count '+tooltipItems.yLabel; 
                      return data.datasets[0].label+' '+tooltipItems.yLabel;
                    }
                }
            },
      }
    },
    straightOptions () {
      return {
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: false
          }]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4
          }
        },
        tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                    label: function(tooltipItems, data) { 
                      // return this.searchLabel;
                        // return 'Search Count '+tooltipItems.yLabel+' - '+data.labels[tooltipItems.index];
                    
                    return data.datasets[0].label+' '+tooltipItems.yLabel;}
                }
            },
      }
    },
    defaultOptions () {
      const options = this.pointed ? this.pointedOptions : this.straightOptions
      return Object.assign({}, options, {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            display: false
          }]
        }
      })
    },
    // translateTooltip() {
    //   let label = this.$t('dashBoard.cChartLineSimple.searchCount');

    //   return label+' ';
    // },
    computedDatasets () {
      return deepObjectsMerge(this.defaultDatasets, this.datasets || {})
    },
    computedOptions () {
      return deepObjectsMerge(this.defaultOptions, this.options || {})
    }
  },
  // created(){
  //   this.searchLabel = this.$t('dashBoard.cChartLineSimple.searchCount');;
  // }
}
</script>
